import React from 'react';
import { awards } from '@/data/mock';
import { Card, CardContent } from '@/components/ui/card';
import { Award, ShieldCheck, Star, Handshake } from 'lucide-react';
import { cn } from '@/lib/utils';

const iconMap = {
  Award,
  ShieldCheck,
  Star,
  Handshake,
};

const AwardsSection = () => {
  return (
    <section className="py-20 bg-slate-900 text-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <p className="text-xs tracking-[0.2em] uppercase text-slate-400">Trust & Recognition</p>
          <h2 className="mt-4 text-3xl md:text-4xl font-semibold leading-tight">
            Program-tested quality systems anchored by national certifications.
          </h2>
          <p className="mt-4 text-slate-300 text-lg">
            Agencies partner with Redspire for disciplined delivery. Independent audits, third-party awards, and
            peer recognition validate that commitment every year.
          </p>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-2">
          {awards.map((awardItem) => {
            const Icon = iconMap[awardItem.icon] || Award;
            return (
              <Card key={awardItem.title} className="bg-white text-slate-900 border border-white/20 shadow-2xl">
                <CardContent className="p-6 flex items-start gap-4">
                  <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-red-600/10 text-red-600 flex items-center justify-center">
                    <Icon className="w-6 h-6" />
                  </div>
                  <div>
                    <p className="text-xs uppercase tracking-[0.3em] text-slate-400">{awardItem.year}</p>
                    <h3 className="mt-2 text-xl font-semibold">{awardItem.title}</h3>
                    <p className="mt-2 text-sm text-slate-600">{awardItem.description}</p>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AwardsSection;

